import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthCliente } from '../context/AuthClienteContext';
import { Center, Spinner } from '@chakra-ui/react';

export default function ProtectedClienteRoute() {
  const { currentUser, loading } = useAuthCliente();

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return currentUser ? <Outlet /> : <Navigate to="/login" />;
}